export default __webpack_public_path__ + "static/media/07Corinne60s.40a4959f.mp3";